import { permissions } from "utils/CommonConstants";

export const headers = [
  { content: "Member" },
  { content: "User type", isSorting: true },
  { content: permissions.ManageTemplatePlans },
  { content: permissions.PlanPermissions, isSorting: true },
  { content: "Admin Console" },
  { content: "Manage Suggestions" },
  { content: "Region", isSorting: true },
  { content: "Last Active", isSorting: true },
  { content: "" }
];
